// extracted by mini-css-extract-plugin
export default {"Backdrop":"styles_Backdrop__4Xo9B","content":"styles_content__ZtASM"};